import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    branches: [],
    loading: false,
    error: null,
};

const branchSlice = createSlice({
    name: 'branch',
    initialState,
    reducers: {
        setBranches: (state, action) => {
            state.branches = action.payload;
        },
        addBranch: (state, action) => {
            state.branches.push(action.payload);
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setBranches, addBranch, setLoading, setError } = branchSlice.actions;
export default branchSlice.reducer;
